
import { Base } from '../../components/base-component';

import './calculators-personalloans-test.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';

export class CalculatorsPersonalloansTest extends Base {

	timeout: any = null;

	inputs: Element[];

	expensesModal: Element[];

	calculatorSubmit: Element[];
	calculatorReset: Element[];
	calculator: HTMLFormElement;

	copyFields: Element[];

	modalLinks: Element[];

	formValid: boolean = true;

	termChecker: HTMLFormElement[];

	constructor(element: Element) {
		super(element);
	}

	init() {
		
		this.inputs = Array.from(this.element.querySelectorAll('input'));

		this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-calculate'));
		this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
		this.calculator = this.element.querySelector('form') as HTMLFormElement;

		this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));

		this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));

		TooltipsService.initTooltips();
	}

	bindEvents() {

		this.calculatorSubmit.map((item) => item.addEventListener('click', (event) => {
			// animate back to top
			if ($(window).width() > 480) {
				$('html,body').animate({
					scrollTop: $('div.calculators').offset().top - 10
				},
					'slow');
			}
			const allFields: any = this.calculator.querySelectorAll('input');
			if (this.formValid) {
				const button : any = event.currentTarget;

				const form =  button.closest("form");

				this.doPLT(form)
				// Analytics - Trigger form Complete when the user calculates the results
				this.analyticsService.dtmFormComplete("complete", "");
			}
		}));

		this.calculatorReset.map((item) => item.addEventListener('click', (event) => {
			this.resetInputs(event)
		}));

		this.copyFields.map((item) => item.addEventListener('input', (event) => {
			this.copyField(event);
		}));

		this.copyFields.map((item) => item.addEventListener('change', (event) => {
			this.copyField(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModal(event);
		}));

		// INPUTS
		this.inputs.map((item) => item.addEventListener('focusin', (event) => {
			this.onFocusInput(event);
		}));

		this.inputs.map((item) => item.addEventListener('focusout', (event) => {
			this.outFocusInput(event);
			this.validationService.validateCalculator(event, this.calculatorSubmit);
			let _valid: Element[] = Array.from(this.element.querySelectorAll('.calculator-form__error'));

			if (_valid.length > 0) {
				this.formValid = false;
				this.calculatorSubmit.map((item) => {
					item.classList.add('button--disabled');
				});
			} else {
				this.formValid = true;
				this.calculatorSubmit.map((item) => {
					item.classList.remove('button--disabled');
				});
			}
		}));

		this.inputs.map((item) => item.addEventListener('keyup', (event) => {
			this.keyInput(event);
		}));

		if (this.termChecker) {
			this.termChecker.map((item) => item.addEventListener('change', (event) => {
				this.checkBaloonPayments(event);
			}));
		}

	}

	openModal(event) {

		let modalId = event.currentTarget.parentNode.getAttribute('data-modal');

		this.event.emit('openModal', {
			id: modalId
		});

	}

	copyField(event) {
		let fieldParentContainer = this.findFieldCopy(event.currentTarget.parentNode);
		let copyValue = parseFloat(event.currentTarget.value);
		let fieldName = fieldParentContainer.getAttribute('data-target');
		let fields = fieldParentContainer.querySelectorAll(`.js-${fieldName}`);

		for (let i = 0; i < fields.length; i++) {
			if (fields[i].classList.contains('js-not-zero')) {
				if (copyValue == 0) {
					copyValue = 1;
				}
			}
			fields[i].value = copyValue;
		}
		// Form form start (if not started yet) when slider is being interacted with
		this.analyticsService.dtmTriggerFormStart(fields[0]);

	}

	findFieldCopy(parent) {
		while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'));
		return parent;
	}

	toggleModifiers(event) {

		event.preventDefault();

		let targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetModifier = this.element.querySelector(`#${targetModifierId}`);

		if (targetModifier.classList.contains('calculator-form__modifiers--open')) {
			targetModifier.classList.remove('calculator-form__modifiers--open');
			event.currentTarget.classList.add('calculator-form__link--open');
		} else {
			targetModifier.classList.add('calculator-form__modifiers--open');
			event.currentTarget.classList.remove('calculator-form__link--open');
		}

	}

	toggleAddons(event) {

		event.preventDefault();

		if (event.currentTarget.classList.contains('link--disabled')) {
			return;
		}

		let targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetAddon = this.element.querySelector('#' + targetAddonId);

		let targetInput = targetAddon.querySelector("input");

		const _tmpText = event.currentTarget.querySelector(".link__text") as HTMLFormElement;
		const _coAppText = this.element.querySelector(".co_app_text") as HTMLFormElement;

		if (targetAddon.classList.contains("calculator-form__addon--open")) {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.remove('calculator-form__addon--open');
			_tmpText.innerText = "+ Add co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "";
			}
		} else {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.add('calculator-form__addon--open');
			_tmpText.innerText = "- Remove co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "(including co-applicant)";
			}
		}
	}

	resetInputs(event) {
		event.preventDefault();

		let errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
		errorLabels.map((item: any) => {
			let parent: any = item;
			$(parent).removeClass('calculator-form__error');
			$(parent).find('div.calculator-form__error-label').remove();
		});

		this.calculator.reset();
		this.formValid = true;
		this.resetValues(this.calculator);

		this.inputs.map((item: any) => {
			if (item.getAttribute('type') != 'radio') {
				item.setAttribute('data-value', 0);
				item.setAttribute('placeholder', 0);
			}
		});

		// Analytics - Trigger form Complete when the user calculates the results
		this.analyticsService.dtmRestartForm();

	}

	onFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;
		let _value = parseFloat(field.value);
		let min = parseFloat(field.getAttribute('min'));
		let max = parseFloat(field.getAttribute('max'));
		if (min && max) {
			if ((_value < min) && (_value > max)) {
				field.value = "";
			}
		} else {
			if (_value == 0) {
				field.value = "";
			}
		}
	}

	outFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;

		if (!field.classList.contains('js-copy-field')) {
			let value = field.getAttribute('data-value');
			// field.value = value;
			if (field.value == '') {
				field.value = value;
			}
		}

		if (field.value == '') {
			field.value = 0;
		}
	}

	keyInput(event) {
		event.preventDefault();
		this.formValid = true;
		let field: any = event.target;
		let value = field.value;

		if (!field.classList.contains('js-copy-field')) {
			field.setAttribute('data-value', value);
			field.setAttribute('placeholder', value);
		}

		this.formValid = this.validationService.validateCalculator(event, this.calculatorSubmit);
	}

	checkBaloonPayments(event) {
		let value = event.currentTarget.value;

		let balloonInput: HTMLFormElement[] = Array.from(this.element.querySelectorAll(".js-balloon"));

		if (balloonInput.length > 0) {
			if (value == '84') {
				balloonInput.forEach(element => {
					element.value = "0";
					element.placeholder = "0";
					element.max = "0";
					element.min = "0";
					element.setAttribute("data-value", "0");
				});
			} else {
				balloonInput.forEach(element => {
					element.value = "1";
					element.placeholder = "1";
					element.max = "40";
					element.min = "1";
					element.setAttribute("data-value", "1");
				});
			}
		}
	}

	//CALCULATOR SERVICES
	doPLT(form: HTMLFormElement) {
		let total: number = 0;
		const loanamount: any = form.querySelector('input[name=loan_amount]');
		total = parseFloat(loanamount.value)
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_borrow: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
		const output_months: any = document.querySelectorAll('span.js-calculator-loan-period-pl1');
		const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
		const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-pl1');
		let btnDoIQualify: HTMLElement[] = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));

		btnDoIQualify.forEach(element => {
			element.classList.remove('button--white');
			element.classList.remove('button--border-blue');
			element.classList.add('gradient-orange');
		});

		const answer = this.PLTMonthlyRepayments(total, interest.value, term.value);

		[].slice.call(output_borrow).forEach(function (div) {
			div.innerHTML = answer.estimatedMonthlyRepayment;
		});
		[].slice.call(output_date).forEach(function (div) {
			div.innerHTML = answer.date;
		});
		[].slice.call(output_fees).forEach(function (div) {
			div.innerHTML = answer.totalInterest;
		});

		
	}

	// PERSONAL LOANS
	PLTMonthlyRepayments(
		loanamount: number = 0,
		loaninterest: number = 0,
		loanterm: number = 10.25
	) {
		const initiationFee: number = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
		const serviceFee: number = 60 * 1.15;

		let normalValue: number = loanamount / loanterm;
		normalValue = this.round(normalValue, 2);

		let final: number = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
		final = this.round(final, 2);

		let interestTotal: number = this.round((final - normalValue), 2);

		let todaysDate: any = new Date();
		let getMonth: number = todaysDate.getMonth();
		todaysDate.setMonth(getMonth + 1, 1);
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		return {
			date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
			iFee: initiationFee,
			sFee: serviceFee,
			totalInterest: this.formatter(interestTotal),
			estimatedMonthlyRepayment: this.formatter(final)
		};
	}

	round(expr, decplaces) {
		let decpoint, str;
		str = '' + Math.round(expr * Math.pow(10, decplaces));
		while (str.length <= decplaces) {
			str = '0' + str;
		}
		decpoint = str.length - decplaces;
		return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
	}

	pmt_vaf(rate: number = 0, period: number = 0, value: number = 0, futurevalue: number = 0, type: number = 0) {
		if (!futurevalue) futurevalue = 0;
		if (!type) type = 0;

		if (rate == 0) return -(value + futurevalue) / period;

		var pvif = Math.pow(1 + rate, period);
		var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);

		if (type == 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	}

	// FORMATTERS
	formatter(value) {
		return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
	}

	// RESET VALUES	- OUTPUTS
	resetValues(form: HTMLFormElement) {
		switch (form.id) {

			case 'calculator-personal_loans_test':
				const loanamount: any = form.querySelector('input[name=loan_amount]');
				const output_borrow_plt: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
				const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
				const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-pl1');
				[].slice.call(loanamount).forEach(function (div) {
					div.innerHTML = '300000';
				});
				[].slice.call(output_borrow_plt).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_date).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_fees).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			default:
				break;
		}
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/calculators-personalloans-test/calculators-personalloans-test.component.ts